import styled from 'styled-components';

interface ContainerProps {
  padding?: string;
  margin?: string;
  width?: string;
  textAlign?: string;
}

export const ThankYouContainer = styled.div<ContainerProps>`
  padding: ${(props) => props.padding || '0'};
  margin: ${(props) => props.margin || '0'};
  width: ${(props) => props.width || '100%'};
  text-align: ${(props) => props.textAlign || 'left'};
  max-width: 1200px;
`;